
export enum FilterOperators {
    isAnyOf = "Is Any Of",
    isNotAnyOf = "Is Not Any Of",
    containAnyOf = "Contain Any Of",
    notContainAnyOf = "Not Contain Any Of"
}
